import request from '@/utils/request'

// # 登录请求
export function login(username, password) {
    return request({
        url: 'sys/auth/login',
        method: 'post',
        data: { username, password }
    })
}

// # 获取登录信息
export function getInfo() {
    return request({
      url: 'sys/auth/info',
      method: 'get'
    })
}

// # 获取代码
export function getCode() {
    return request({
      url: 'sys/auth/code',
      method: 'get'
    })
}

// # 退出登录
export function logout() {
    return request({
      url: 'sys/auth/logout',
      method: 'delete'
    })
}